/* RESPONSIBLE TEAM: team-ai-insights */

import type { CxBenchmarkData } from 'embercom/components/reporting/bespoke/fin-performance/cx-benchmark-panel/types';

// Generated from Snowflake data for 2026-03.
// To regenerate: run extract_benchmarks.sql in Snowsight, download CSV,
// then run: python3 transform_benchmarks.py <csv_file>
export const CX_BENCHMARK_DATA: CxBenchmarkData = {
  benchmarks: {
    'ecommerce:15k_to_100k': {
      percentiles: {
        p5: 0.5105,
        p10: 0.5378,
        p15: 0.5583,
        p20: 0.5819,
        p25: 0.5924,
        p30: 0.6121,
        p35: 0.6338,
        p40: 0.6641,
        p45: 0.679,
        p50: 0.6848,
        p55: 0.6932,
        p60: 0.7048,
        p65: 0.7105,
        p70: 0.7158,
        p75: 0.7369,
        p80: 0.7554,
        p85: 0.782,
        p90: 0.8283,
        p95: 0.8386,
        p100: 0.8768,
      },
      reasons: {
        answer_quality_bot_high: 0.7796,
        answer_quality_bot_low: 0.0561,
        product_feedback_positive: 0.0107,
        product_feedback_negative: 0.1451,
        policy_feedback_positive: 0.0015,
        policy_feedback_negative: 0.1061,
        user_strong_emotion_positive: 0.0116,
        user_strong_emotion_negative: 0.089,
        user_effort_low: 0.5603,
        user_effort_high: 0.2017,
      },
      score_distribution: {
        score_1: 0.008,
        score_2: 0.1091,
        score_3: 0.2019,
        score_4: 0.226,
        score_5: 0.455,
      },
    },

    'ecommerce:1k_to_15k': {
      percentiles: {
        p5: 0.4954,
        p10: 0.5712,
        p15: 0.5797,
        p20: 0.5983,
        p25: 0.6084,
        p30: 0.6331,
        p35: 0.6485,
        p40: 0.6642,
        p45: 0.6801,
        p50: 0.6965,
        p55: 0.7191,
        p60: 0.7339,
        p65: 0.7389,
        p70: 0.7465,
        p75: 0.7625,
        p80: 0.7898,
        p85: 0.8013,
        p90: 0.82,
        p95: 0.8414,
        p100: 0.9138,
      },
      reasons: {
        answer_quality_bot_high: 0.7565,
        answer_quality_bot_low: 0.0601,
        product_feedback_positive: 0.0108,
        product_feedback_negative: 0.1284,
        policy_feedback_positive: 0.0014,
        policy_feedback_negative: 0.0861,
        user_strong_emotion_positive: 0.0098,
        user_strong_emotion_negative: 0.0673,
        user_effort_low: 0.5395,
        user_effort_high: 0.2361,
      },
      score_distribution: {
        score_1: 0.0068,
        score_2: 0.117,
        score_3: 0.1739,
        score_4: 0.2262,
        score_5: 0.476,
      },
    },

    'ecommerce:overall': {
      percentiles: {
        p5: 0.4928,
        p10: 0.5522,
        p15: 0.5726,
        p20: 0.5945,
        p25: 0.608,
        p30: 0.6306,
        p35: 0.645,
        p40: 0.6642,
        p45: 0.679,
        p50: 0.692,
        p55: 0.705,
        p60: 0.7273,
        p65: 0.7368,
        p70: 0.746,
        p75: 0.7625,
        p80: 0.7866,
        p85: 0.8014,
        p90: 0.8208,
        p95: 0.8475,
        p100: 0.9138,
      },
      reasons: {
        answer_quality_bot_high: 0.7565,
        answer_quality_bot_low: 0.0595,
        product_feedback_positive: 0.0108,
        product_feedback_negative: 0.1399,
        policy_feedback_positive: 0.0011,
        policy_feedback_negative: 0.0861,
        user_strong_emotion_positive: 0.0095,
        user_strong_emotion_negative: 0.0729,
        user_effort_low: 0.5394,
        user_effort_high: 0.2272,
      },
      score_distribution: {
        score_1: 0.0072,
        score_2: 0.1196,
        score_3: 0.1728,
        score_4: 0.225,
        score_5: 0.4753,
      },
    },

    'education:1k_to_15k': {
      percentiles: {
        p5: 0.4821,
        p10: 0.5103,
        p15: 0.5652,
        p20: 0.5879,
        p25: 0.6038,
        p30: 0.643,
        p35: 0.6568,
        p40: 0.6806,
        p45: 0.7077,
        p50: 0.7168,
        p55: 0.7246,
        p60: 0.7409,
        p65: 0.7613,
        p70: 0.7831,
        p75: 0.7877,
        p80: 0.8082,
        p85: 0.8202,
        p90: 0.8349,
        p95: 0.8616,
        p100: 0.9781,
      },
      reasons: {
        answer_quality_bot_high: 0.7646,
        answer_quality_bot_low: 0.0524,
        product_feedback_positive: 0.0072,
        product_feedback_negative: 0.1235,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0574,
        user_strong_emotion_positive: 0.0084,
        user_strong_emotion_negative: 0.0572,
        user_effort_low: 0.4909,
        user_effort_high: 0.2579,
      },
      score_distribution: {
        score_1: 0.0047,
        score_2: 0.106,
        score_3: 0.159,
        score_4: 0.2189,
        score_5: 0.5114,
      },
    },

    'education:overall': {
      percentiles: {
        p5: 0.4952,
        p10: 0.5196,
        p15: 0.573,
        p20: 0.5946,
        p25: 0.6062,
        p30: 0.637,
        p35: 0.6599,
        p40: 0.6806,
        p45: 0.7021,
        p50: 0.7135,
        p55: 0.7238,
        p60: 0.7383,
        p65: 0.7602,
        p70: 0.7737,
        p75: 0.7834,
        p80: 0.7912,
        p85: 0.8114,
        p90: 0.8278,
        p95: 0.8571,
        p100: 0.9781,
      },
      reasons: {
        answer_quality_bot_high: 0.7586,
        answer_quality_bot_low: 0.0562,
        product_feedback_positive: 0.0072,
        product_feedback_negative: 0.1224,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0571,
        user_strong_emotion_positive: 0.0084,
        user_strong_emotion_negative: 0.0615,
        user_effort_low: 0.4953,
        user_effort_high: 0.2656,
      },
      score_distribution: {
        score_1: 0.0049,
        score_2: 0.1103,
        score_3: 0.1561,
        score_4: 0.221,
        score_5: 0.5077,
      },
    },

    'fintech:15k_to_100k': {
      percentiles: {
        p5: 0.4082,
        p10: 0.4804,
        p15: 0.5151,
        p20: 0.543,
        p25: 0.5706,
        p30: 0.5885,
        p35: 0.6035,
        p40: 0.6221,
        p45: 0.6355,
        p50: 0.6469,
        p55: 0.6743,
        p60: 0.6977,
        p65: 0.7166,
        p70: 0.7343,
        p75: 0.7552,
        p80: 0.7709,
        p85: 0.8001,
        p90: 0.8291,
        p95: 0.8489,
        p100: 0.9497,
      },
      reasons: {
        answer_quality_bot_high: 0.7455,
        answer_quality_bot_low: 0.0669,
        product_feedback_positive: 0.0045,
        product_feedback_negative: 0.0814,
        policy_feedback_positive: 0.001,
        policy_feedback_negative: 0.089,
        user_strong_emotion_positive: 0.005,
        user_strong_emotion_negative: 0.0813,
        user_effort_low: 0.5183,
        user_effort_high: 0.2554,
      },
      score_distribution: {
        score_1: 0.0066,
        score_2: 0.1367,
        score_3: 0.1887,
        score_4: 0.2153,
        score_5: 0.4528,
      },
    },

    'fintech:1k_to_15k': {
      percentiles: {
        p5: 0.4273,
        p10: 0.4996,
        p15: 0.5416,
        p20: 0.5645,
        p25: 0.5854,
        p30: 0.6106,
        p35: 0.6259,
        p40: 0.6399,
        p45: 0.6617,
        p50: 0.677,
        p55: 0.6977,
        p60: 0.7105,
        p65: 0.7339,
        p70: 0.7496,
        p75: 0.768,
        p80: 0.7875,
        p85: 0.8147,
        p90: 0.8308,
        p95: 0.8557,
        p100: 0.9469,
      },
      reasons: {
        answer_quality_bot_high: 0.7367,
        answer_quality_bot_low: 0.0657,
        product_feedback_positive: 0.0056,
        product_feedback_negative: 0.1137,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.079,
        user_strong_emotion_positive: 0.0061,
        user_strong_emotion_negative: 0.0678,
        user_effort_low: 0.4647,
        user_effort_high: 0.2849,
      },
      score_distribution: {
        score_1: 0.0069,
        score_2: 0.1288,
        score_3: 0.1769,
        score_4: 0.2303,
        score_5: 0.4571,
      },
    },

    'fintech:overall': {
      percentiles: {
        p5: 0.427,
        p10: 0.4916,
        p15: 0.5306,
        p20: 0.56,
        p25: 0.5848,
        p30: 0.6026,
        p35: 0.6218,
        p40: 0.637,
        p45: 0.6595,
        p50: 0.675,
        p55: 0.6965,
        p60: 0.7107,
        p65: 0.7319,
        p70: 0.7494,
        p75: 0.7686,
        p80: 0.7905,
        p85: 0.8144,
        p90: 0.8324,
        p95: 0.8599,
        p100: 0.9497,
      },
      reasons: {
        answer_quality_bot_high: 0.7443,
        answer_quality_bot_low: 0.0656,
        product_feedback_positive: 0.0049,
        product_feedback_negative: 0.1046,
        policy_feedback_positive: 0.0006,
        policy_feedback_negative: 0.0824,
        user_strong_emotion_positive: 0.0057,
        user_strong_emotion_negative: 0.0671,
        user_effort_low: 0.4814,
        user_effort_high: 0.2704,
      },
      score_distribution: {
        score_1: 0.0066,
        score_2: 0.1285,
        score_3: 0.1809,
        score_4: 0.2228,
        score_5: 0.4611,
      },
    },

    'fintech:under_1k': {
      percentiles: {
        p5: 0.498,
        p10: 0.5459,
        p15: 0.5606,
        p20: 0.5897,
        p25: 0.6074,
        p30: 0.6274,
        p35: 0.6421,
        p40: 0.6611,
        p45: 0.6782,
        p50: 0.6952,
        p55: 0.7056,
        p60: 0.7252,
        p65: 0.7455,
        p70: 0.7896,
        p75: 0.8008,
        p80: 0.8128,
        p85: 0.8286,
        p90: 0.86,
        p95: 0.8828,
        p100: 0.9333,
      },
      reasons: {
        answer_quality_bot_high: 0.7593,
        answer_quality_bot_low: 0.0686,
        product_feedback_positive: 0.0046,
        product_feedback_negative: 0.1111,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0511,
        user_strong_emotion_positive: 0.0053,
        user_strong_emotion_negative: 0.0585,
        user_effort_low: 0.448,
        user_effort_high: 0.2677,
      },
      score_distribution: {
        score_1: 0.0045,
        score_2: 0.1201,
        score_3: 0.1675,
        score_4: 0.2222,
        score_5: 0.4858,
      },
    },

    'gaming_and_gambling:overall': {
      percentiles: {
        p5: 0.3236,
        p10: 0.3654,
        p15: 0.4,
        p20: 0.4344,
        p25: 0.476,
        p30: 0.4915,
        p35: 0.5148,
        p40: 0.5275,
        p45: 0.5381,
        p50: 0.5556,
        p55: 0.5623,
        p60: 0.57,
        p65: 0.5734,
        p70: 0.5996,
        p75: 0.6427,
        p80: 0.6497,
        p85: 0.6834,
        p90: 0.7062,
        p95: 0.7386,
        p100: 0.7965,
      },
      reasons: {
        answer_quality_bot_high: 0.6488,
        answer_quality_bot_low: 0.0877,
        product_feedback_positive: 0.0033,
        product_feedback_negative: 0.1378,
        policy_feedback_positive: 0.0003,
        policy_feedback_negative: 0.1583,
        user_strong_emotion_positive: 0.0058,
        user_strong_emotion_negative: 0.1288,
        user_effort_low: 0.4,
        user_effort_high: 0.2952,
      },
      score_distribution: {
        score_1: 0.0206,
        score_2: 0.1779,
        score_3: 0.2538,
        score_4: 0.2146,
        score_5: 0.3332,
      },
    },

    'healthcare:1k_to_15k': {
      percentiles: {
        p5: 0.4856,
        p10: 0.5648,
        p15: 0.584,
        p20: 0.6218,
        p25: 0.6375,
        p30: 0.6555,
        p35: 0.6706,
        p40: 0.6867,
        p45: 0.7036,
        p50: 0.7161,
        p55: 0.7263,
        p60: 0.7437,
        p65: 0.7566,
        p70: 0.7648,
        p75: 0.7781,
        p80: 0.7949,
        p85: 0.8066,
        p90: 0.8271,
        p95: 0.8494,
        p100: 0.8994,
      },
      reasons: {
        answer_quality_bot_high: 0.7614,
        answer_quality_bot_low: 0.0627,
        product_feedback_positive: 0.0062,
        product_feedback_negative: 0.1121,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0489,
        user_strong_emotion_positive: 0.0065,
        user_strong_emotion_negative: 0.0606,
        user_effort_low: 0.5446,
        user_effort_high: 0.2475,
      },
      score_distribution: {
        score_1: 0.0055,
        score_2: 0.1133,
        score_3: 0.1632,
        score_4: 0.2205,
        score_5: 0.4974,
      },
    },

    'healthcare:overall': {
      percentiles: {
        p5: 0.4627,
        p10: 0.5358,
        p15: 0.5829,
        p20: 0.6187,
        p25: 0.6366,
        p30: 0.6577,
        p35: 0.6742,
        p40: 0.6921,
        p45: 0.7029,
        p50: 0.7165,
        p55: 0.725,
        p60: 0.7439,
        p65: 0.7566,
        p70: 0.7691,
        p75: 0.7851,
        p80: 0.8018,
        p85: 0.8127,
        p90: 0.8283,
        p95: 0.8863,
        p100: 0.9082,
      },
      reasons: {
        answer_quality_bot_high: 0.7597,
        answer_quality_bot_low: 0.0606,
        product_feedback_positive: 0.0048,
        product_feedback_negative: 0.1092,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.055,
        user_strong_emotion_positive: 0.0064,
        user_strong_emotion_negative: 0.0592,
        user_effort_low: 0.55,
        user_effort_high: 0.237,
      },
      score_distribution: {
        score_1: 0.0057,
        score_2: 0.1139,
        score_3: 0.1601,
        score_4: 0.2154,
        score_5: 0.505,
      },
    },

    'hospitality_and_tourism:overall': {
      percentiles: {
        p5: 0.538,
        p10: 0.6215,
        p15: 0.6303,
        p20: 0.6508,
        p25: 0.686,
        p30: 0.6953,
        p35: 0.6997,
        p40: 0.7031,
        p45: 0.7052,
        p50: 0.7275,
        p55: 0.7414,
        p60: 0.7518,
        p65: 0.7739,
        p70: 0.7823,
        p75: 0.801,
        p80: 0.8256,
        p85: 0.8575,
        p90: 0.8928,
        p95: 0.9108,
        p100: 0.927,
      },
      reasons: {
        answer_quality_bot_high: 0.7721,
        answer_quality_bot_low: 0.0517,
        product_feedback_positive: 0.0047,
        product_feedback_negative: 0.0854,
        policy_feedback_positive: 0.0029,
        policy_feedback_negative: 0.0704,
        user_strong_emotion_positive: 0.0081,
        user_strong_emotion_negative: 0.0454,
        user_effort_low: 0.5409,
        user_effort_high: 0.2168,
      },
      score_distribution: {
        score_1: 0.0039,
        score_2: 0.102,
        score_3: 0.1535,
        score_4: 0.2288,
        score_5: 0.5117,
      },
    },

    'manufacturing:1k_to_15k': {
      percentiles: {
        p5: 0.5942,
        p10: 0.6046,
        p15: 0.624,
        p20: 0.6414,
        p25: 0.6569,
        p30: 0.6865,
        p35: 0.7021,
        p40: 0.7388,
        p45: 0.7526,
        p50: 0.76,
        p55: 0.7677,
        p60: 0.7741,
        p65: 0.7773,
        p70: 0.7976,
        p75: 0.8038,
        p80: 0.8122,
        p85: 0.826,
        p90: 0.8382,
        p95: 0.8672,
        p100: 0.8894,
      },
      reasons: {
        answer_quality_bot_high: 0.8448,
        answer_quality_bot_low: 0.0471,
        product_feedback_positive: 0.0135,
        product_feedback_negative: 0.0844,
        policy_feedback_positive: 0.0003,
        policy_feedback_negative: 0.0447,
        user_strong_emotion_positive: 0.0093,
        user_strong_emotion_negative: 0.0424,
        user_effort_low: 0.622,
        user_effort_high: 0.1491,
      },
      score_distribution: {
        score_1: 0.0077,
        score_2: 0.0758,
        score_3: 0.1568,
        score_4: 0.194,
        score_5: 0.5656,
      },
    },

    'manufacturing:overall': {
      percentiles: {
        p5: 0.4288,
        p10: 0.5477,
        p15: 0.6017,
        p20: 0.6244,
        p25: 0.6475,
        p30: 0.6759,
        p35: 0.6918,
        p40: 0.7259,
        p45: 0.7491,
        p50: 0.755,
        p55: 0.7683,
        p60: 0.7762,
        p65: 0.7976,
        p70: 0.8053,
        p75: 0.8137,
        p80: 0.8234,
        p85: 0.8289,
        p90: 0.8354,
        p95: 0.8701,
        p100: 0.8894,
      },
      reasons: {
        answer_quality_bot_high: 0.84,
        answer_quality_bot_low: 0.0586,
        product_feedback_positive: 0.0103,
        product_feedback_negative: 0.1021,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0466,
        user_strong_emotion_positive: 0.0084,
        user_strong_emotion_negative: 0.0552,
        user_effort_low: 0.5667,
        user_effort_high: 0.2022,
      },
      score_distribution: {
        score_1: 0.009,
        score_2: 0.08,
        score_3: 0.1506,
        score_4: 0.197,
        score_5: 0.5633,
      },
    },

    'media_and_entertainment:overall': {
      percentiles: {
        p5: 0.4783,
        p10: 0.5106,
        p15: 0.5296,
        p20: 0.5585,
        p25: 0.5636,
        p30: 0.5824,
        p35: 0.6023,
        p40: 0.6236,
        p45: 0.6389,
        p50: 0.6471,
        p55: 0.6533,
        p60: 0.6914,
        p65: 0.7201,
        p70: 0.7301,
        p75: 0.7398,
        p80: 0.7537,
        p85: 0.7844,
        p90: 0.8008,
        p95: 0.8131,
        p100: 0.838,
      },
      reasons: {
        answer_quality_bot_high: 0.6978,
        answer_quality_bot_low: 0.068,
        product_feedback_positive: 0.0051,
        product_feedback_negative: 0.127,
        policy_feedback_positive: 0.0005,
        policy_feedback_negative: 0.0828,
        user_strong_emotion_positive: 0.0097,
        user_strong_emotion_negative: 0.1082,
        user_effort_low: 0.4211,
        user_effort_high: 0.2935,
      },
      score_distribution: {
        score_1: 0.0149,
        score_2: 0.1607,
        score_3: 0.1612,
        score_4: 0.2289,
        score_5: 0.4342,
      },
    },

    'other:1k_to_15k': {
      percentiles: {
        p5: 0.4641,
        p10: 0.5394,
        p15: 0.5503,
        p20: 0.5771,
        p25: 0.5948,
        p30: 0.6559,
        p35: 0.6617,
        p40: 0.6898,
        p45: 0.6941,
        p50: 0.7111,
        p55: 0.7178,
        p60: 0.7281,
        p65: 0.7367,
        p70: 0.7594,
        p75: 0.7699,
        p80: 0.805,
        p85: 0.8452,
        p90: 0.853,
        p95: 0.8984,
        p100: 0.9378,
      },
      reasons: {
        answer_quality_bot_high: 0.7663,
        answer_quality_bot_low: 0.0623,
        product_feedback_positive: 0.006,
        product_feedback_negative: 0.1137,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0631,
        user_strong_emotion_positive: 0.0066,
        user_strong_emotion_negative: 0.0607,
        user_effort_low: 0.4888,
        user_effort_high: 0.248,
      },
      score_distribution: {
        score_1: 0.0094,
        score_2: 0.1137,
        score_3: 0.1706,
        score_4: 0.2071,
        score_5: 0.4993,
      },
    },

    'other:overall': {
      percentiles: {
        p5: 0.4746,
        p10: 0.5386,
        p15: 0.5547,
        p20: 0.5864,
        p25: 0.6024,
        p30: 0.6388,
        p35: 0.6586,
        p40: 0.6791,
        p45: 0.6919,
        p50: 0.7031,
        p55: 0.716,
        p60: 0.7288,
        p65: 0.7391,
        p70: 0.7645,
        p75: 0.7781,
        p80: 0.7889,
        p85: 0.8191,
        p90: 0.8485,
        p95: 0.8853,
        p100: 0.9378,
      },
      reasons: {
        answer_quality_bot_high: 0.7519,
        answer_quality_bot_low: 0.0619,
        product_feedback_positive: 0.0073,
        product_feedback_negative: 0.1229,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0665,
        user_strong_emotion_positive: 0.0064,
        user_strong_emotion_negative: 0.0655,
        user_effort_low: 0.5,
        user_effort_high: 0.246,
      },
      score_distribution: {
        score_1: 0.0091,
        score_2: 0.1248,
        score_3: 0.1661,
        score_4: 0.2123,
        score_5: 0.4877,
      },
    },

    'other:under_1k': {
      percentiles: {
        p5: 0.4966,
        p10: 0.5979,
        p15: 0.6306,
        p20: 0.6408,
        p25: 0.6612,
        p30: 0.6791,
        p35: 0.6851,
        p40: 0.6985,
        p45: 0.703,
        p50: 0.7213,
        p55: 0.7436,
        p60: 0.7706,
        p65: 0.7773,
        p70: 0.7795,
        p75: 0.7847,
        p80: 0.7876,
        p85: 0.8023,
        p90: 0.824,
        p95: 0.855,
        p100: 0.9091,
      },
      reasons: {
        answer_quality_bot_high: 0.7507,
        answer_quality_bot_low: 0.0557,
        product_feedback_positive: 0.0149,
        product_feedback_negative: 0.1843,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0823,
        user_strong_emotion_positive: 0.0063,
        user_strong_emotion_negative: 0.0625,
        user_effort_low: 0.5122,
        user_effort_high: 0.2284,
      },
      score_distribution: {
        score_1: 0.0059,
        score_2: 0.1244,
        score_3: 0.1454,
        score_4: 0.2192,
        score_5: 0.5051,
      },
    },

    'overall:100k_to_1m': {
      percentiles: {
        p5: 0.3486,
        p10: 0.4004,
        p15: 0.4856,
        p20: 0.5253,
        p25: 0.5621,
        p30: 0.5831,
        p35: 0.6008,
        p40: 0.6216,
        p45: 0.6458,
        p50: 0.6761,
        p55: 0.6845,
        p60: 0.7012,
        p65: 0.7136,
        p70: 0.7231,
        p75: 0.7427,
        p80: 0.758,
        p85: 0.777,
        p90: 0.7911,
        p95: 0.8219,
        p100: 0.9208,
      },
      reasons: {
        answer_quality_bot_high: 0.7,
        answer_quality_bot_low: 0.0751,
        product_feedback_positive: 0.0028,
        product_feedback_negative: 0.1052,
        policy_feedback_positive: 0.0002,
        policy_feedback_negative: 0.0803,
        user_strong_emotion_positive: 0.0033,
        user_strong_emotion_negative: 0.0596,
        user_effort_low: 0.3937,
        user_effort_high: 0.3094,
      },
      score_distribution: {
        score_1: 0.0063,
        score_2: 0.1334,
        score_3: 0.1934,
        score_4: 0.2335,
        score_5: 0.4334,
      },
    },

    'overall:15k_to_100k': {
      percentiles: {
        p5: 0.4224,
        p10: 0.491,
        p15: 0.532,
        p20: 0.5587,
        p25: 0.5741,
        p30: 0.5915,
        p35: 0.6043,
        p40: 0.6175,
        p45: 0.6369,
        p50: 0.6596,
        p55: 0.679,
        p60: 0.6992,
        p65: 0.713,
        p70: 0.7266,
        p75: 0.7437,
        p80: 0.7587,
        p85: 0.7771,
        p90: 0.814,
        p95: 0.8399,
        p100: 0.9497,
      },
      reasons: {
        answer_quality_bot_high: 0.7257,
        answer_quality_bot_low: 0.0653,
        product_feedback_positive: 0.0046,
        product_feedback_negative: 0.1184,
        policy_feedback_positive: 0.0008,
        policy_feedback_negative: 0.0818,
        user_strong_emotion_positive: 0.006,
        user_strong_emotion_negative: 0.0785,
        user_effort_low: 0.48,
        user_effort_high: 0.2849,
      },
      score_distribution: {
        score_1: 0.0076,
        score_2: 0.1339,
        score_3: 0.186,
        score_4: 0.2251,
        score_5: 0.4474,
      },
    },

    'overall:1k_to_15k': {
      percentiles: {
        p5: 0.4585,
        p10: 0.514,
        p15: 0.5551,
        p20: 0.5821,
        p25: 0.6077,
        p30: 0.6291,
        p35: 0.6507,
        p40: 0.6676,
        p45: 0.6846,
        p50: 0.7013,
        p55: 0.7147,
        p60: 0.7302,
        p65: 0.7426,
        p70: 0.7568,
        p75: 0.7738,
        p80: 0.7911,
        p85: 0.8071,
        p90: 0.8283,
        p95: 0.8607,
        p100: 0.9781,
      },
      reasons: {
        answer_quality_bot_high: 0.7417,
        answer_quality_bot_low: 0.062,
        product_feedback_positive: 0.0063,
        product_feedback_negative: 0.1352,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0472,
        user_strong_emotion_positive: 0.0063,
        user_strong_emotion_negative: 0.0579,
        user_effort_low: 0.4609,
        user_effort_high: 0.2883,
      },
      score_distribution: {
        score_1: 0.006,
        score_2: 0.1197,
        score_3: 0.1703,
        score_4: 0.2293,
        score_5: 0.4747,
      },
    },

    'overall:overall': {
      percentiles: {
        p5: 0.4568,
        p10: 0.5148,
        p15: 0.555,
        p20: 0.5821,
        p25: 0.6063,
        p30: 0.6284,
        p35: 0.6477,
        p40: 0.6658,
        p45: 0.6829,
        p50: 0.7005,
        p55: 0.7137,
        p60: 0.7298,
        p65: 0.7434,
        p70: 0.7583,
        p75: 0.7758,
        p80: 0.7932,
        p85: 0.8112,
        p90: 0.8309,
        p95: 0.8636,
        p100: 0.9781,
      },
      reasons: {
        answer_quality_bot_high: 0.7423,
        answer_quality_bot_low: 0.0628,
        product_feedback_positive: 0.0058,
        product_feedback_negative: 0.1332,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0493,
        user_strong_emotion_positive: 0.006,
        user_strong_emotion_negative: 0.0596,
        user_effort_low: 0.4569,
        user_effort_high: 0.2882,
      },
      score_distribution: {
        score_1: 0.0061,
        score_2: 0.1209,
        score_3: 0.1688,
        score_4: 0.2284,
        score_5: 0.4759,
      },
    },

    'overall:under_1k': {
      percentiles: {
        p5: 0.5113,
        p10: 0.5504,
        p15: 0.602,
        p20: 0.6258,
        p25: 0.6455,
        p30: 0.6628,
        p35: 0.6803,
        p40: 0.6982,
        p45: 0.7129,
        p50: 0.7303,
        p55: 0.7445,
        p60: 0.7658,
        p65: 0.7788,
        p70: 0.7911,
        p75: 0.8034,
        p80: 0.8186,
        p85: 0.8334,
        p90: 0.8571,
        p95: 0.8775,
        p100: 0.9375,
      },
      reasons: {
        answer_quality_bot_high: 0.7593,
        answer_quality_bot_low: 0.0623,
        product_feedback_positive: 0.0065,
        product_feedback_negative: 0.1452,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.036,
        user_strong_emotion_positive: 0.0049,
        user_strong_emotion_negative: 0.0534,
        user_effort_low: 0.4506,
        user_effort_high: 0.288,
      },
      score_distribution: {
        score_1: 0.005,
        score_2: 0.1118,
        score_3: 0.1469,
        score_4: 0.2277,
        score_5: 0.5086,
      },
    },

    'professional_services:1k_to_15k': {
      percentiles: {
        p5: 0.4732,
        p10: 0.5261,
        p15: 0.546,
        p20: 0.562,
        p25: 0.5791,
        p30: 0.6099,
        p35: 0.6457,
        p40: 0.6773,
        p45: 0.7085,
        p50: 0.7213,
        p55: 0.7293,
        p60: 0.7518,
        p65: 0.7692,
        p70: 0.7843,
        p75: 0.7862,
        p80: 0.7884,
        p85: 0.8032,
        p90: 0.8185,
        p95: 0.8686,
        p100: 0.8867,
      },
      reasons: {
        answer_quality_bot_high: 0.7612,
        answer_quality_bot_low: 0.0584,
        product_feedback_positive: 0.0059,
        product_feedback_negative: 0.1137,
        policy_feedback_positive: 0.0018,
        policy_feedback_negative: 0.054,
        user_strong_emotion_positive: 0.0071,
        user_strong_emotion_negative: 0.0448,
        user_effort_low: 0.5068,
        user_effort_high: 0.2542,
      },
      score_distribution: {
        score_1: 0.0046,
        score_2: 0.1136,
        score_3: 0.1611,
        score_4: 0.2122,
        score_5: 0.5085,
      },
    },

    'professional_services:overall': {
      percentiles: {
        p5: 0.4007,
        p10: 0.5206,
        p15: 0.5421,
        p20: 0.5666,
        p25: 0.58,
        p30: 0.6175,
        p35: 0.652,
        p40: 0.6861,
        p45: 0.7098,
        p50: 0.7228,
        p55: 0.7378,
        p60: 0.7509,
        p65: 0.7655,
        p70: 0.7844,
        p75: 0.7879,
        p80: 0.7933,
        p85: 0.8175,
        p90: 0.861,
        p95: 0.8728,
        p100: 0.9083,
      },
      reasons: {
        answer_quality_bot_high: 0.7582,
        answer_quality_bot_low: 0.0588,
        product_feedback_positive: 0.0059,
        product_feedback_negative: 0.1066,
        policy_feedback_positive: 0.002,
        policy_feedback_negative: 0.06,
        user_strong_emotion_positive: 0.0065,
        user_strong_emotion_negative: 0.0464,
        user_effort_low: 0.5235,
        user_effort_high: 0.2471,
      },
      score_distribution: {
        score_1: 0.0049,
        score_2: 0.1114,
        score_3: 0.1651,
        score_4: 0.2126,
        score_5: 0.5061,
      },
    },

    'real_estate:1k_to_15k': {
      percentiles: {
        p5: 0.4655,
        p10: 0.4802,
        p15: 0.5154,
        p20: 0.5573,
        p25: 0.6174,
        p30: 0.6508,
        p35: 0.6624,
        p40: 0.6699,
        p45: 0.6735,
        p50: 0.6761,
        p55: 0.6956,
        p60: 0.7235,
        p65: 0.7333,
        p70: 0.7416,
        p75: 0.7503,
        p80: 0.7616,
        p85: 0.7669,
        p90: 0.7869,
        p95: 0.8335,
        p100: 0.8904,
      },
      reasons: {
        answer_quality_bot_high: 0.7225,
        answer_quality_bot_low: 0.0697,
        product_feedback_positive: 0.0066,
        product_feedback_negative: 0.1398,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0463,
        user_strong_emotion_positive: 0.0041,
        user_strong_emotion_negative: 0.0488,
        user_effort_low: 0.4662,
        user_effort_high: 0.3248,
      },
      score_distribution: {
        score_1: 0.0058,
        score_2: 0.1383,
        score_3: 0.1669,
        score_4: 0.2111,
        score_5: 0.478,
      },
    },

    'real_estate:overall': {
      percentiles: {
        p5: 0.4639,
        p10: 0.4863,
        p15: 0.5242,
        p20: 0.5584,
        p25: 0.607,
        p30: 0.6385,
        p35: 0.6588,
        p40: 0.6697,
        p45: 0.6714,
        p50: 0.6761,
        p55: 0.6959,
        p60: 0.7197,
        p65: 0.7308,
        p70: 0.7421,
        p75: 0.7522,
        p80: 0.7664,
        p85: 0.7839,
        p90: 0.8056,
        p95: 0.8276,
        p100: 0.8904,
      },
      reasons: {
        answer_quality_bot_high: 0.7225,
        answer_quality_bot_low: 0.0697,
        product_feedback_positive: 0.0061,
        product_feedback_negative: 0.1398,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0472,
        user_strong_emotion_positive: 0.0051,
        user_strong_emotion_negative: 0.0518,
        user_effort_low: 0.4561,
        user_effort_high: 0.3279,
      },
      score_distribution: {
        score_1: 0.0064,
        score_2: 0.1414,
        score_3: 0.1703,
        score_4: 0.2139,
        score_5: 0.4679,
      },
    },

    'software_and_technology:100k_to_1m': {
      percentiles: {
        p5: 0.3958,
        p10: 0.5595,
        p15: 0.578,
        p20: 0.5865,
        p25: 0.6159,
        p30: 0.6291,
        p35: 0.6458,
        p40: 0.6712,
        p45: 0.6823,
        p50: 0.6946,
        p55: 0.7019,
        p60: 0.7115,
        p65: 0.7169,
        p70: 0.739,
        p75: 0.7512,
        p80: 0.764,
        p85: 0.7819,
        p90: 0.7911,
        p95: 0.8055,
        p100: 0.8229,
      },
      reasons: {
        answer_quality_bot_high: 0.7059,
        answer_quality_bot_low: 0.0806,
        product_feedback_positive: 0.0024,
        product_feedback_negative: 0.1093,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0129,
        user_strong_emotion_positive: 0.0022,
        user_strong_emotion_negative: 0.0432,
        user_effort_low: 0.3826,
        user_effort_high: 0.3299,
      },
      score_distribution: {
        score_1: 0.0033,
        score_2: 0.1128,
        score_3: 0.1868,
        score_4: 0.2512,
        score_5: 0.4458,
      },
    },

    'software_and_technology:15k_to_100k': {
      percentiles: {
        p5: 0.4278,
        p10: 0.5113,
        p15: 0.5547,
        p20: 0.5741,
        p25: 0.5887,
        p30: 0.6012,
        p35: 0.6148,
        p40: 0.6309,
        p45: 0.6574,
        p50: 0.672,
        p55: 0.7085,
        p60: 0.7205,
        p65: 0.736,
        p70: 0.7451,
        p75: 0.7571,
        p80: 0.7726,
        p85: 0.7955,
        p90: 0.8175,
        p95: 0.8372,
        p100: 0.8726,
      },
      reasons: {
        answer_quality_bot_high: 0.7249,
        answer_quality_bot_low: 0.0609,
        product_feedback_positive: 0.004,
        product_feedback_negative: 0.1388,
        policy_feedback_positive: 0.0005,
        policy_feedback_negative: 0.036,
        user_strong_emotion_positive: 0.0052,
        user_strong_emotion_negative: 0.0662,
        user_effort_low: 0.3883,
        user_effort_high: 0.3264,
      },
      score_distribution: {
        score_1: 0.0058,
        score_2: 0.123,
        score_3: 0.1811,
        score_4: 0.2409,
        score_5: 0.4491,
      },
    },

    'software_and_technology:1k_to_15k': {
      percentiles: {
        p5: 0.4642,
        p10: 0.5233,
        p15: 0.5591,
        p20: 0.5889,
        p25: 0.6134,
        p30: 0.6369,
        p35: 0.6593,
        p40: 0.6738,
        p45: 0.6907,
        p50: 0.7061,
        p55: 0.7152,
        p60: 0.7309,
        p65: 0.7434,
        p70: 0.7572,
        p75: 0.7753,
        p80: 0.7919,
        p85: 0.805,
        p90: 0.8278,
        p95: 0.8607,
        p100: 0.9702,
      },
      reasons: {
        answer_quality_bot_high: 0.7377,
        answer_quality_bot_low: 0.0611,
        product_feedback_positive: 0.0061,
        product_feedback_negative: 0.1509,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0333,
        user_strong_emotion_positive: 0.0057,
        user_strong_emotion_negative: 0.0533,
        user_effort_low: 0.4206,
        user_effort_high: 0.3127,
      },
      score_distribution: {
        score_1: 0.0053,
        score_2: 0.1163,
        score_3: 0.1668,
        score_4: 0.2373,
        score_5: 0.4743,
      },
    },

    'software_and_technology:overall': {
      percentiles: {
        p5: 0.4659,
        p10: 0.5304,
        p15: 0.5683,
        p20: 0.5965,
        p25: 0.6193,
        p30: 0.6407,
        p35: 0.6603,
        p40: 0.6765,
        p45: 0.6937,
        p50: 0.7091,
        p55: 0.7218,
        p60: 0.7369,
        p65: 0.7486,
        p70: 0.7641,
        p75: 0.7813,
        p80: 0.797,
        p85: 0.8138,
        p90: 0.8356,
        p95: 0.8639,
        p100: 0.9702,
      },
      reasons: {
        answer_quality_bot_high: 0.739,
        answer_quality_bot_low: 0.062,
        product_feedback_positive: 0.0057,
        product_feedback_negative: 0.1501,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0312,
        user_strong_emotion_positive: 0.0052,
        user_strong_emotion_negative: 0.0532,
        user_effort_low: 0.4191,
        user_effort_high: 0.3123,
      },
      score_distribution: {
        score_1: 0.0052,
        score_2: 0.1155,
        score_3: 0.1636,
        score_4: 0.2379,
        score_5: 0.4778,
      },
    },

    'software_and_technology:under_1k': {
      percentiles: {
        p5: 0.5143,
        p10: 0.5871,
        p15: 0.6169,
        p20: 0.6365,
        p25: 0.6544,
        p30: 0.6678,
        p35: 0.6893,
        p40: 0.7083,
        p45: 0.7216,
        p50: 0.7337,
        p55: 0.7466,
        p60: 0.7667,
        p65: 0.7793,
        p70: 0.7939,
        p75: 0.8079,
        p80: 0.8248,
        p85: 0.8399,
        p90: 0.8599,
        p95: 0.8793,
        p100: 0.9375,
      },
      reasons: {
        answer_quality_bot_high: 0.7582,
        answer_quality_bot_low: 0.0622,
        product_feedback_positive: 0.0066,
        product_feedback_negative: 0.1633,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0264,
        user_strong_emotion_positive: 0.004,
        user_strong_emotion_negative: 0.0476,
        user_effort_low: 0.4286,
        user_effort_high: 0.3019,
      },
      score_distribution: {
        score_1: 0.0041,
        score_2: 0.1089,
        score_3: 0.1445,
        score_4: 0.2338,
        score_5: 0.5086,
      },
    },

    'transportation:1k_to_15k': {
      percentiles: {
        p5: 0.4719,
        p10: 0.4872,
        p15: 0.5688,
        p20: 0.5942,
        p25: 0.6043,
        p30: 0.6097,
        p35: 0.614,
        p40: 0.6225,
        p45: 0.6266,
        p50: 0.6364,
        p55: 0.6597,
        p60: 0.6781,
        p65: 0.6838,
        p70: 0.7102,
        p75: 0.7315,
        p80: 0.7468,
        p85: 0.7747,
        p90: 0.7909,
        p95: 0.7968,
        p100: 0.8377,
      },
      reasons: {
        answer_quality_bot_high: 0.701,
        answer_quality_bot_low: 0.083,
        product_feedback_positive: 0.0037,
        product_feedback_negative: 0.0898,
        policy_feedback_positive: 0.0008,
        policy_feedback_negative: 0.0714,
        user_strong_emotion_positive: 0.0054,
        user_strong_emotion_negative: 0.0723,
        user_effort_low: 0.471,
        user_effort_high: 0.2616,
      },
      score_distribution: {
        score_1: 0.0071,
        score_2: 0.1543,
        score_3: 0.2007,
        score_4: 0.2245,
        score_5: 0.4134,
      },
    },

    'transportation:overall': {
      percentiles: {
        p5: 0.4707,
        p10: 0.4945,
        p15: 0.5313,
        p20: 0.5941,
        p25: 0.6043,
        p30: 0.6122,
        p35: 0.6205,
        p40: 0.628,
        p45: 0.636,
        p50: 0.6536,
        p55: 0.678,
        p60: 0.6843,
        p65: 0.7011,
        p70: 0.7236,
        p75: 0.7334,
        p80: 0.765,
        p85: 0.7738,
        p90: 0.7921,
        p95: 0.8275,
        p100: 0.8591,
      },
      reasons: {
        answer_quality_bot_high: 0.7155,
        answer_quality_bot_low: 0.0855,
        product_feedback_positive: 0.0038,
        product_feedback_negative: 0.0881,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0873,
        user_strong_emotion_positive: 0.0052,
        user_strong_emotion_negative: 0.0674,
        user_effort_low: 0.48,
        user_effort_high: 0.2616,
      },
      score_distribution: {
        score_1: 0.0076,
        score_2: 0.1383,
        score_3: 0.1864,
        score_4: 0.2372,
        score_5: 0.4306,
      },
    },
  },
};
